const ABOUT_IMG =
  "https://images.pexels.com/photos/8123801/pexels-photo-8123801.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function About() {
  return (
    <section className="bg-cream py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 sm:px-12 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <img src={ABOUT_IMG} alt="Senior advisors in boardroom" className="aspect-[5/4] w-full rounded-md object-cover shadow-xl" />
        </div>
        <div className="lg:col-span-6 lg:pl-6">
          <p className="text-xs uppercase tracking-[0.2em] text-terracotta">About SeedTechNG</p>
          <h2 className="mt-3 font-display text-4xl font-semibold text-umber sm:text-5xl">
            African ambition, <span className="italic">international</span> standards.
          </h2>
          <p className="mt-6 text-lg text-umber/75">
            We were founded by African founders who lost too many funding rounds to one thing: poorly prepared documents.
          </p>
          <p className="mt-4 text-umber/70">
            Today our team of analysts, ex-VC associates and grant specialists prepare the same calibre of financial
            models, data rooms and applications that top-tier funds and foundations expect — built specifically for the
            realities of African businesses.
          </p>

          <dl className="mt-10 grid grid-cols-2 gap-6">
            {[
              ["94%", "application success rate"],
              ["$48M+", "total raised by clients"],
              ["14", "countries we operate in"],
              ["120+", "businesses served"],
            ].map(([n, l]) => (
              <div key={l} className="border-l-2 border-terracotta pl-4">
                <dt className="font-display text-3xl font-semibold text-umber">{n}</dt>
                <dd className="text-[11px] uppercase tracking-[0.15em] text-umber/60">{l}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
